import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { Form, Input, Modal, Popover, Select, Image,Tooltip, } from "antd";
import axios from "axios";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getRequest } from "../../api/http";
import userapiservice from "../../api/userapiservice";
import { GlobalContext } from "../../components/globalContext/GlobalContext";
import {
  CloseActive,
  Filter,
  FilterSlider,
  ProfileClose,
  SearchZoomActive,
} from "../../components/Icons/Icons";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import usePartnerName from "../../hooks/usePartnerName";
import OrganiationSizes from "../../json/organizationSize.json";
import location_red_new from "../../assets/newImages/browse_icon.png";


import {
  setOrganisationType as localStorageSetOrganisationType,
  setSize as localStorageSetSize,
  setInterestAndAssetType,
  setPage,
  setPartner,
  setSearchName,
  setSector,
  setState,
  setSubSector,
  setTabValue,
  updateCountry,
  updateCounty,
  setPartnerId as updatePartnerId,
  updateOrganisationNameById,
  setCountry
} from "../../Reducer/localStorageSlice";
import { handleErrorMessage, truncate } from "../../utils/helper";
import { typeOfDevice } from "../../utils/util";
import "./PartnerPage.scss";
import PartnerCarousel from "./partnerSlider";
import { inputFieldCharLimit } from "../../config";
import { setPartnerData } from "../../Reducer/globalSlice";
import SearchEngine from "../../assets/images/search-engine.png";

import PoweredByDatacity  from "../../assets/images/powered_by_datacity_light.png";

const interest = [
  "",
  "PRODUCT",
  "SERVICE",
  "CONTRACTS",
  "VACANCY",
  "APPRENTICESHIP",
  "WORK_EXPERIENCE",
  "COURSES",
];

const LogoCarousel = ({ partnerLogos, type }) => {
  const { globalState } = useContext(GlobalContext);

  // const extendedPartnerLogos = useMemo(() => [...partnerLogos, ...partnerLogos], [partnerLogos]);
  const extendedPartnerLogos = useMemo(() => partnerLogos, [partnerLogos]);

  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      setScrollPosition((prevPosition) => {
        // Calculate the new scroll position (scrolling up)
        const newPosition = prevPosition - 1;

        // Reset the scroll position when it reaches the end
        if (newPosition < -(extendedPartnerLogos?.length * 29)) {
          return 0;
        }

        return newPosition;
      });
    }, 50); // Adjust the interval for scrolling speed
    // }, 50000000); // Adjust the interval for scrolling speed

    return () => clearInterval(scrollInterval);
  }, [extendedPartnerLogos]);

  return (
    <div
      className={`overflow-hidden row p-0 ${
        window.innerHeight < 650 ? "my-md-2" : "my-md-4"
      } mx-auto ${
        type === "mobile"
          ? extendedPartnerLogos?.length < 5
            ? "min-height-unset"
            : "min-height-set"
          : ""
      }  business-partners-wrapper`}
    >
      <div className="our-business-partners-container  pb-0 p-md-2 d-flex align-items-center justify-content-center text-capitalize ">
        <strong className="our-business-partners ">
          Our Business Partners
        </strong>
      </div>

      <div className="business-partners-list overflow-hidden p-0">
        <div
          className={`${
            globalState.isMobile ? "mt-3" : ""
          } overflow-hidden h-100`}
        >
          <div
            className={`business-partners-list-container ${
              type !== "mobile" && extendedPartnerLogos?.length === 0
                ? "height"
                : ""
            } ${
              type === "mobile"
                ? extendedPartnerLogos?.length < 5
                  ? "set-max-height"
                  : "reset-max-height"
                : ""
            }  row m-md-0 p-0 d-flex  justify-content-center`}
            style={{
              transform: `translateY(${
                extendedPartnerLogos?.length < 5 ? 0 : scrollPosition
              }px)`,
              cursor: "pointer",
            }}
          >
            {extendedPartnerLogos?.length === 0 && (
              <div className="empty-partner">
                No partner logos are currently available
              </div>
            )}

            {extendedPartnerLogos.map((partner, index) => (
              <div
                key={index}
                onClick={() =>
                  window.open(
                    partner?.urlLink.startsWith("https://")
                      ? partner?.urlLink
                      : `https://${partner?.urlLink}`,
                    "_blank"
                  )
                }
                className="p-0 partner-wrapper"
              >
                <div className="partner-image d-flex justify-content-center align-items-center ">
                  <div className="partnerLogoBox">
                    <div className="partnerLogoCol">
                      <img
                        src={partner?.mediaLink?.url}
                        height="50px"
                        style={{ maxHeight: "50px" }}
                        alt="Partner Logo"
                      />
                    </div>
                    {/* <div className="partnerLogoCol">{truncate(partner?.description, 60)}</div> */}
                  </div>
                </div>
                {/* <div
                  className="partner-description h-100 d-none d-md-block "
                >
                  {truncate(partner?.description, 60)}
                </div> */}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default function PartnerPage() {
  const dispatch = useDispatch();
  const localData = useSelector((state) => state?.localStorage);
  const {
    partnerId: persistPartnerId,
    sector: sectorValue,
    size: localDataSize,
    ["Interest/AssetType"]: interestAssetType,
    subSector: subSectorId,
    OrganisationType,
    subSectorResponse
  } = localData;

  const type = typeOfDevice();
  const { globalState, setGlobalState } = useContext(GlobalContext);
  const { formattedName: partner } = usePartnerName();
  const filtersPopUp = useRef(null);
  const navigate = useNavigate();

  const [partnerLogos, setPartnerLogos] = useState([]);
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [organisationType, setOrganisationType] = useState([]);
  const [subSectors, setSubSectors] = useState([]);

  const [FilterSearchOrganisationFor, setFilterSearchOrganisationFor] =
    useState("");
  const [FilterOrganisationType, setFilterOrganisationType] = useState(() => {
    return OrganisationType || "";
  });
  const [FilterCategories, setFilterCategories] = useState(sectorValue || "");
  const [FilterSizeValue, setFilterSizeValue] = useState(localDataSize || "");
  const [FilterSubSector, setFilterSubSector] = useState(subSectorId);

  const [partnerLogo, setPartnerLogo] = useState(null);
  const [partnerCarousel, setPartnerCarousel] = useState(null);
  const [loading, setLoading] = useState(false);
  const [SearchKeyWord, setSearchKeyWord] = useState("");

  const [partnerId, setPartnerId] = useState(persistPartnerId);

  const [sectors, setSectors] = useState([]);
  const [openHome, setOpenHome] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);

  // Map Related
  const [size] = useState(localDataSize || null);
  const [interestName] = useState(interestAssetType || "");

  useEffect(() => {
    setFilterSearchOrganisationFor(interestAssetType || "");
    if (subSectorResponse) {
      setSubSectors(subSectorResponse);
    }
  },[subSectorResponse])

  const getPartnersLogo = async (partnerName) => {
    try {
      const response = await getRequest(
        userapiservice.getPartnerSupporterLogo(partnerName)
      );
      if (response) {
        setPartnerLogos(response);
      }
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={handleErrorMessage(error, "Failed to fetch Partner logos")}
        />
      );
    }
  };
  const handleFreeTextChange = (e) => {
    setSearchKeyWord(e.target.value);
    dispatch(setSearchName(e.target.value));
  };
  const clearSearchKeyword = () => {
    setSearchKeyWord("");
    dispatch(setSearchName(""));
  };
  const getPartnerLogo = async (partner) => {
    try {
      const response = await getRequest(
        userapiservice.getPartnerDetails(partner)
      );
      if (response) {
        setPartnerLogo(response);
        setPartnerId(response.id);
        dispatch(updatePartnerId(response?.id));
        dispatch(setPartnerData(response));
      }
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  const getPartnerCarousel = async (partner) => {
    setLoading(false);
    try {
      const response = await getRequest(
        userapiservice.getPartnerCarousel(partner)
      );
      setPartnerCarousel(
        response?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      );
      setLoading(true);
    } catch (e) {
      setLoading(false);
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  const getSubSector = async (sectorId) => {
    try {
      const response = await getRequest(userapiservice.getSubSectors(sectorId));
      setSubSectors(response);
    } catch (error) {
      toast.error(
        <ToastComponent
          type={"Error"}
          message={handleErrorMessage(error, "Failed to fetch SubSectors")}
        />
      );
    }
  };

  const onSector = async (sectorId) => {
    setFilterCategories(sectorId);
    if (sectorId) {
      try {
        const response = await getRequest(
          // userapiservice.getSubSectors(sectorId)
          userapiservice.getSubSectorsForFilter(sectorId)
          
        );
        setSubSectors(response);
      } catch (error) {
        toast.error(
          <ToastComponent
            type={"Error"}
            message={handleErrorMessage(error, "Failed to fetch SubSectors")}
          />
        );
      }
    } else {
      setFilterSubSector("");
      setSubSectors(null);
    }
  };

  const SizeChange = async (size) => {
    setFilterSizeValue(size);
  };

  const subSectorChange = async (subSectorIds) => {
    setFilterSubSector(subSectorIds);
  };

  const fetchSectorList = async (partnerId) => {
    try {
      const response = await getRequest(
        userapiservice.getAllSectors(partnerId)
      );
      setSectors(response);
      if (sectorValue) {
        // setSectorValue(sectorId);
        dispatch(setSector(sectorValue));
      }
      if (size) {
      }
    } catch (error) {}
  };

  const onOrgInterest = (value) => {
    setFilterOrganisationType(value);
    const name = organisationType?.find(
      (type) => type?.id === value
    )?.displayName;
    dispatch(updateOrganisationNameById(name));
  };

  const onInterest = (e) => {
    setFilterSearchOrganisationFor(e);
    dispatch(setInterestAndAssetType(e));
    if (e === "PRODUCT") {
      dispatch(setTabValue("product"));
    } else if (e === "SERVICE") {
      dispatch(setTabValue("service"));
    } else if (e === "CONTRACTS") {
      dispatch(setTabValue("contract"));
    } else if (e === "VACANCY") {
      dispatch(setTabValue("vacancy"));
    } else if (e === "APPRENTICESHIP") {
      dispatch(setTabValue("apprenticeship"));
    } else {
      dispatch(setTabValue("work-experience"));
    }
  };

  const searchClick = () => {
    setOpenHome(true);
  };

  const handleFilter = () => {
    // make dispatches so local storage is updated with filter data

    dispatch(localStorageSetOrganisationType(FilterOrganisationType));
    dispatch(setSector(FilterCategories));
    dispatch(setSubSector(FilterSubSector));
    dispatch(localStorageSetSize(FilterSizeValue));
  };

  const searchHandleKeyDown = (e) => {
    if (e.key === "Enter") {
      searchClick(e);
    }
  };

  const handleClickOutside = (event) => {
    if (
      filtersPopUp.current &&
      !filtersPopUp.current.contains(event.target) &&
      !event.target.closest(".ant-select-dropdown")
    ) {
      setOpenFilter(false);
    }
  };

  const Filters = () => {
    return (
      <motion.div
        className="filter-modal-window-container"
        animate={{ opacity: 1, scale: 1 }}
        transition={{
          duration: 0.8,
          delay: 0.5,
          ease: [0, 0.71, 0.2, 1.01],
        }}
      >
        <Form className="p-2 profile-filters-form ">
          <div className=" row ">
            <Form.Item className="col-12 col-md-6 form-item pr-md-3">
              <label className="label-text">Search organisations for</label>
              <Select
                value={FilterSearchOrganisationFor}
                placeholder="Select interest"
                onChange={(e) => onInterest(e)}
              >
                {interest?.map((Search, i) => (
                  <Select.Option key={i} value={interest[i]}>
                    {interest[i] === ""
                      ? "All"
                      : interest[i] === "APPRENTICESHIP"
                      ? "Apprenticeships"
                      : interest[i] === "VACANCY"
                      ? "Vacancies"
                      : interest[i] === "PRODUCT"
                      ? "Products"
                      : interest[i] === "CONTRACTS"
                      ? "Contracts"
                      : interest[i] === "SERVICE"
                      ? "Services"
                      : interest[i] === "WORK_EXPERIENCE"
                      ? "Experiences of work"
                      : interest[i] === "COURSES"
                      ? "Courses"
                      : interest[i] === "CONTRACTS"
                      ? "Contracts"
                      : ""}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item className="col-12 col-md-6 form-item pr-md-3">
              <label className="label-text">Organisation Type</label>
              <Select
                value={FilterOrganisationType || "All"}
                placeholder="Select Organization Type"
                onChange={onOrgInterest}
              >
                {organisationType.map((type) => (
                  <Select.Option key={type.id} value={type.id}>
                    {type?.displayName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item className="col-12 col-md-6 form-item pl-md-3">
              <div className="label-with-logo">
                <label>Categories</label>
                <img
                  src={PoweredByDatacity}
                  alt="Powered by Datacity"
                  className="powered-by-logo"
                />
              </div>
              <Select
                value={FilterCategories}
                placeholder="Select Sector"
                onChange={(e) => {
                  dispatch(setSubSector(""));
                  setFilterSubSector("");
                }}
                onSelect={(e) => {
                  onSector(e);
                }}
              >
                <Select.Option value="">All</Select.Option>
                {sectors?.map((Sector, i) => (
                  <Select.Option key={i} value={Sector.id}>
                    {Sector.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item className="col-12 col-md-6 form-item pr-md-3">
              <div className="label-with-logo">
                <label>Sub categories</label>
                <img
                  src={PoweredByDatacity}
                  alt="Powered by Datacity"
                  className="powered-by-logo"
                />
              </div>
              <Select
                value={FilterSubSector}
                placeholder="Select Subsector"
                onSelect={(e) => {
                  subSectorChange(e);
                }}
                 disabled={!FilterCategories}   
              >
                <Select.Option value="">All</Select.Option>
                {subSectors &&
                  subSectors?.map((subSector, i) => (
                    <Select.Option key={i} value={subSector.id}>
                      {subSector.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
          <div className=" row ">
            {/* <Form.Item className="col-12 col-md-6 form-item pr-md-3">
              <label>Sub categories</label>
              <Select
                value={subSectorValue}
                placeholder="Select Subsector"
                onSelect={(e) => {
                  subSectorChange(e);
                }}
              >
                <Select.Option value="">All</Select.Option>
                {subSectors &&
                  subSectors?.map((subSector, i) => (
                    <Select.Option key={i} value={subSector.id}>
                      {subSector.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item> */}
            <Form.Item className="col-12 col-md-6 form-item pl-md-3">
              <label>Size by employees</label>
              <Select value={FilterSizeValue} onChange={(e) => SizeChange(e)}>
                <Select.Option value="">All</Select.Option>
                {OrganiationSizes.map((OrganiationSize, i) => (
                  <Select.Option key={i} value={OrganiationSize.id}>
                    {OrganiationSize.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          {/* <div className="filters-submit-btn-container" >
          <Form.Item className="d-flex justify-content-end mb-0" >
            <button
              className="btn btn-danger  filters-submit-btn"
              type="submit"
              onClick={(e) => { searchClick(e); setOpenFilter(false) }}
            >
              <span>Search</span>
            </button>
          </Form.Item>
        </div> */}
          <div className="filters-submit-btn-container">
            <Form.Item className="d-flex justify-content-end mb-0">
              {globalState.isMobile && openFilter && (
                <button
                  className="btn filters-submit-btn"
                  style={{ background: "#908a8a" }}
                  type="submit"
                  onClick={() => {
                    setOpenFilter(false);
                  }}
                >
                  <span>Cancel</span>
                </button>
              )}

              <button
                className="btn btn-primary filters-submit-btn"
                type="submit"
                onClick={(e) => {
                  handleFilter();
                  searchClick(e);
                  setOpenFilter(false);
                }}
              >
                <span>Filter Results</span>
              </button>
            </Form.Item>
          </div>
        </Form>
      </motion.div>
    );
  };

  const getOnOrganisationType = async (partnerId) => {
    try {
      const response = await getRequest(
        userapiservice.getOnOrganisationType(partnerId)
      );
      if (response) {
        setOrganisationType(response);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (globalState.partner !== partner) {
      setGlobalState((prevState) => ({ ...prevState, partner: partner }));
    }
    if (globalState.partnerId !== partnerId) {
      setGlobalState((prevState) => ({ ...prevState, partnerId: partnerId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner, partnerId]);

  useEffect(() => {
    dispatch(setPartner(partner));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner]);

  const getCountryFromCoords = async (lat, lng) => {
  const res = await fetch(
    `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
  );
  const data = await res.json();
  return data.address.country;
};


  useEffect(() => {
navigator.geolocation.getCurrentPosition(async (pos) => {
  const { latitude, longitude } = pos.coords;
  const country = await getCountryFromCoords(latitude, longitude);
  dispatch(setCountry(country));
  localStorage.setItem("country", country);
});
  },[])

  useEffect(() => {
    const createdUser = "";
    if (createdUser !== "created") {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setLatitude(position.coords.latitude);
            setLongitude(position.coords.longitude);
          },
          (error) => {
            console.error(error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    }
  }, []);

  useEffect(() => {
    const createdUser = "";
    if (createdUser !== "created") {
      if (latitude && longitude) {
        async function getWeather() {
          let res = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=geojson&zoom=8&lat=${latitude}&lon=${longitude}`
          );
          // https://nominatim.org/release-docs/develop/api/Reverse/#example-with-formatgeojson
          // For more info on the OSM API, refer the link mentioned above
          dispatch(
            updateCountry(res.data?.features[0]?.properties?.address?.country)
          );
          dispatch(setCountry(res.data?.features[0]?.properties?.address?.country));
          if (res.data?.features[0]?.properties?.address?.county) {
            dispatch(
              updateCounty(res.data?.features[0]?.properties?.address?.county)
            );
          } else if (
            res.data?.features[0]?.properties?.address?.state_district
          ) {
            dispatch(
              updateCounty(
                res.data?.features[0]?.properties?.address?.state_district
              )
            );
          } else if (res.data?.features[0]?.properties?.address?.municipality) {
            dispatch(
              updateCounty(
                res.data?.features[0]?.properties?.address?.municipality
              )
            );
          } else if (res.data?.features[0]?.properties?.address?.town) {
            dispatch(
              updateCounty(res.data?.features[0]?.properties?.address?.town)
            );
          } else {
            dispatch(
              updateCounty(res.data?.features[0]?.properties?.address?.city)
            );
          }

          dispatch(setState(res.data?.features[0]?.properties?.address?.state));
        }
        getWeather();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [latitude, longitude]);

  useEffect(() => {
    if (partner) {
      getPartnersLogo(partner);
    }
  }, [partner]);

  useEffect(() => {
    if (globalState.partner !== partner) {
      setGlobalState((prevState) => ({ ...prevState, partner: partner }));
    }
    if (globalState.partnerId !== partnerId) {
      setGlobalState((prevState) => ({ ...prevState, partnerId: partnerId }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner, partnerId]);

  useEffect(() => {
    if (openHome) {
      navigate("/microsite");
    }
    setOpenHome(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openHome]);

  useEffect(() => {
    if (partner) {
      getPartnerLogo(partner);
      getPartnerCarousel(partner);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner, sectorValue, subSectorId, size, interestName]);

  useEffect(() => {
    partnerId && getOnOrganisationType(partnerId);
  }, [partnerId]);

  useEffect(() => {
    if (partner && partnerId) {
      fetchSectorList(partnerId);
      dispatch(setPage("partner"));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner, partnerId]);

  useEffect(() => {
    if (partner && sectorValue) {
      // getSubSector(sectorValue);
      
    }
  }, [partner, sectorValue]);

  useEffect(() => {
    if (!globalState.isMobile) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`main-body-container d-flex flex-column ${
        globalState.isMobile
          ? "body-container-mobile bg-white"
          : "body-container-desktop"
      }`}
      style={{
        backgroundImage: `${
          partnerLogo?.wallpaperToggle === true && !globalState.isMobile
            ? `url(${partnerLogo?.wallpaper})`
            : `none`
        }`,
        backgroundColor: `${
          partnerLogo?.wallpaperToggle === true && !globalState.isMobile
            ? `none`
            : "#F6F6F6"
        }`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div
        className={`main-body ${
          globalState.isMobile ? "body-mobile" : "body-desktop"
        }`}
      >
        <div className=" partner-page-container">
          <h3 className="partner-page-org-title">{partnerLogo?.siteName}</h3>

          {loading && (
            <div
              className={`partner-page-carousel ${
                !globalState.isMobile ? "bordered-container" : ""
              }   bg-white`}
            >
              <PartnerCarousel carouselData={partnerCarousel} />
            </div>
          )}

          {loading && (
            <>
              <div
                className={`partner-page-logos-and-search ${
                  globalState.isMobile ? "my-0 " : "bordered-container"
                } align-items-center bg-white ${
                  partnerLogos?.length < 5
                    ? "partner-page-logos-and-search-flex-grow-0"
                    : ""
                } `}
              >
                <div
                  className={`d-flex search-wrapper ${
                    globalState.isMobile ? "w-100 p-0" : "w-md-75"
                  }`}
                >
                  
                  <div
                    className="title-bar-search-wrapper"
                    style={{ width: "100%" }}
                  >
                    <div className="search-engin-wrapper">
                        <Link to="/microsite" title="Browse Organisations">
                            <Image
                              preview={false}
                              src={location_red_new}
                              className="searchEngineIcon"
                            />
                          </Link>
                    </div>
                    <Input
                      onChange={handleFreeTextChange}
                      placeholder="Search for Businesses"
                      className="h-100 w-100 main-search"
                      onKeyDown={searchHandleKeyDown}
                      value={SearchKeyWord}
                      maxLength={inputFieldCharLimit}
                      prefix={
                        <span className="d-flex align-items-center gap-1">

                        
                          <SearchZoomActive customClassName="search-icon-landing-page" />
                        </span>
                      }
                      suffix={
                        <span className="align-items-center d-flex gap-1">
                          {SearchKeyWord.length > 0 && (
                            <button
                              onClick={() => clearSearchKeyword()}
                              className="btn btn-sm  "
                            >
                              <CloseActive />
                            </button>
                          )}
                          <Popover
                            destroyTooltipOnHide
                            content={
                              <div
                                ref={filtersPopUp}
                                className="partner-page-filters-popup"
                              >
                                <Filters />
                              </div>
                            }
                            trigger="click"
                            open={!globalState.isMobile && openFilter}
                            onOpenChange={() => {
                              setOpenFilter(!openFilter);
                            }}
                            placement="bottomRight"
                          >
                            <button
                              className="btn btn-sm"
                              // type="button"
                              onClick={() => {
                                setOpenFilter(true);
                              }}
                            >
                              <FilterSlider
                                onClick={() => {
                                  setOpenFilter(true);
                                }}
                              />
                            </button>
                          </Popover>
                        </span>
                      }
                    />
                  </div>
                </div>
                <div
                  className={` d-flex partners-logo-carousel  ${
                    partnerLogos?.length < 5
                      ? "partners-logo-carousel-height-unset"
                      : ""
                  }`}
                >
                  <LogoCarousel partnerLogos={partnerLogos} type={type} />
                </div>
              </div>
            </>
          )}

          {loading && (
            <div className="partner-page-join-now bordered-container bg-white d-flex">
                         <div className="partner-org-logo-container">
            <img
                  src={partnerLogo?.mediaLink}
                  className="partner-org-logo"
                  alt="logo"
                />
              </div>

              <p className="description">
                {/* Organization Login page description  */}
               {/* <span  title={partnerLogo?.description} className="description-text">{partnerLogo?.description}</span> */}
           <Popover
                  content={<div style={{ maxWidth: 300 }}>{partnerLogo?.description}</div>}
                  placement="topLeft"
                  trigger={globalState.isMobile ? "click" : ["hover", "focus"]}
                  overlayClassName="partner-description-tooltip"
                >
                  <span
                    className="description-text"
                    role="button"
                    tabIndex={0}
                    aria-label={partnerLogo?.description}
                  >
                    {partnerLogo?.endUserPageDescription}
                  </span>
                </Popover>
                </p>

               <a
                // href={partnerLogo?.membershipLink}
                href={partnerLogo?.website}

                target="_blank"
                rel="noreferrer"
                className={`btn join-now-btn btn-primary text-white ${
                  globalState.isMobile ? "btn-sm" : "btn-block"
                } ${partnerLogo?.website ? "" : "disabled"}`}
              >
                Find Out More
              </a>
            </div>
          )}

          <Modal
            centered
            closable={false}
            footer={false}
            open={globalState.isMobile && openFilter}
            className="filters-modal-wrapper"
          >
            <div className="d-flex align-items-center justify-content-between title-bar position-relative">
              <div className="mobile-filter-icon">
                {/* <Filter /> */}
                <FilterSlider/>
              </div>
              <div className="mobile-filter-close-icon">
                <button
                  className="btn btn-small p-0"
                  onClick={() => {
                    setOpenFilter(false);
                  }}
                >
                  <ProfileClose />
                </button>
              </div>
            </div>
            <Filters />
          </Modal>
        </div>
      </div>
    </div>
  );
}
